export enum BookingTypeEnum {
  CLIENT_SELF = 'client_self',
  MANAGER_CREATED = 'manager_created',
}
